import { CompareLayerProps } from '@oneaudi/audi-compare-layer-package';
import { CatalogItemType } from '~/graphql/types';

export const getCorrectTrimline = (
	trimlines: CatalogItemType['trimline'][],
	engine: CompareLayerProps['data']['selectedDriveTrain'],
) => {
	return trimlines.find((t) => t.featureId === engine?.trimlineId);
};
